
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5.135c1.082 0 1.056 1.854 1.056 1.854s0 2.009.051 4.017-.72 2.318-.72 2.318l-.052.258v2.369h1.442c.257 0 .257.103.257.103l-.103 1.082-.103-.413H7.835v2.627l-.103.31-.31.205v-.206l-.257-.515v-2.472H5.672l-.103.412-.103-1.082s0-.103.257-.103h1.442L7.114 8.53l-.052-.257s-.772-.31-.772-2.267V1.99S6.318.186 7.348.135H7.5z"}})])
          )
        }
      }
    